<template>
  <TheTemplateM class="p-the-page-m03">
    <template #body>
      <div class="p-the-page-m03__form c-form-inner">
        <ValidationObserver v-slot="ObserverProps" slim>
          <form
            ref="form"
            action="/profile-update/"
            method="post"
            @submit.prevent="submit(ObserverProps)"
          >
            <FormConsent
              class="p-the-page-m03__consent"
              @link-clicked="enableCheckbox"
            >
              <ValidationProvider
                v-slot="ProviderProps"
                rules="consentRequired"
              >
                <div class="p-the-page-m03__consent__checkbox">
                  <InputCheckBox
                    v-model="consent"
                    :disabled="ischeckBoxDisabled"
                    name="consent"
                    :error="ProviderProps.errors[0]"
                    @checked="onCheckConsent()"
                    >利用規約に同意する</InputCheckBox
                  >
                </div>
              </ValidationProvider>

              <input v-model="consent_time" type="hidden" name="consent_time" />
            </FormConsent>

            <div class="p-form-button-group">
              <div class="p-form-button-group__vertical">
                <ButtonMain
                  type="submit"
                  :disabled="ObserverProps.invalid"
                  @click-button="submitPage"
                  >同意して進む</ButtonMain
                >
              </div>
              <div class="p-form-button-group__vertical">
                <ButtonMain :tag="'a'" href="/my-page/" :kind="'cancel'"
                  >キャンセル</ButtonMain
                >
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </template>
  </TheTemplateM>
</template>

<script lang="ts">
import TheTemplateM from "@/general/components/templates/TheTemplateM.vue";
import FormConsent from "@/common/components/organisms/FormConsent.vue";
import InputCheckBox from "@/common/components/atoms/InputCheckBox.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import ValidationErrorText from "@/common/components/atoms/ValidationErrorText.vue";
import { Options, Vue } from "vue-class-component";
import commons from "@/common/store/modules/commons";
import { required } from "@vee-validate/rules";
import { defineRule } from "vee-validate";

defineRule("consentRequired", required);

@Options({
  components: {
    TheTemplateM,
    FormConsent,
    InputCheckBox,
    ButtonMain
  },
  watch: {
    consent() {
      this.consent_time = Date.now();
    }
  }
})
export default class TermsOfService extends Vue {
  ischeckBoxDisabled = true;
  consent: any = "";
  consent_time!: any;
  breadcrumb = [
    {
      text: "",
      url: "/home",
      pageType: "home"
    },
    {
      text: "マイページ",
      url: "/my-page",
      pageType: "lower"
    },
    {
      text: "個人情報同意確認",
      url: "/",
      pageType: "lower"
    }
  ];

  submit(ObserverProps: any) {
    ObserverProps.passes(() => {
      this.$refs.form as Vue & { submit: () => any };
    });
  }
  submitPage() {
    window.location.href = "/personal-information";
  }
  async created() {
    await commons.setOrgPageSpecificDataFromLocalStorage();
    await commons.getBreadcrumb(this.breadcrumb);
  }

  onCheckConsent() {
    if (this.consent === "") {
      this.consent = 1;
    } else {
      this.consent = "";
    }
  }

  enableCheckbox() {
    this.ischeckBoxDisabled = false;
  }
}
</script>

<style lang="scss" scoped>
.p-the-page-m03 {
  &__consent {
    &__checkbox {
      margin-bottom: rem(-12);
      display: flex;
      justify-content: center;
    }
  }
}
</style>
